__webpack_require__.p = "https://prod.getstarted-katal-mons.amazonautos.amazon.dev/";